// Shows the photoreal character sprite on a themed backdrop (falls back to nothing if missing).
const base = `${process.env.PUBLIC_URL || ""}/game-assets`;

export const CharacterPortrait = ({ character, size = 130 }) => {
  return (
    <div
      className="pixel-card relative overflow-hidden flex items-center justify-center w-full"
      style={{ maxWidth: size, aspectRatio: "1 / 1", background: `linear-gradient(160deg, ${character.colors.accent}, #111)` }}
      data-testid={`portrait-${character.id}`}
    >
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "repeating-linear-gradient(45deg,#fff 0 6px,transparent 6px 14px)" }} />
      <img
        src={`${base}/${character.spriteId || (character.variants && character.variants[0].sprite) || character.id}.webp`}
        alt={character.name}
        className="relative float-up"
        style={{ maxHeight: "86%", maxWidth: "86%", objectFit: "contain", imageRendering: "auto", filter: "drop-shadow(2px 4px 4px rgba(0,0,0,0.5))" }}
        draggable={false}
      />
    </div>
  );
};
